import { Route as SuppliersRoute } from "@/routes/(pharma)/_layout/suppliers/index";
import { useQuery } from "@tanstack/react-query";
import { getSuppliers } from "../-data/api";
import type { Supplier } from "@/gen/suppliers/common_pb";
import { ListSuppliersResponse } from "@/gen/suppliers/list_suppliers_pb";

interface SupplierQueryResult {
    suppliers: Supplier[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export const useSuppliersData = () => {
  const searchParams = SuppliersRoute.useSearch();
  
  const page = (searchParams.page || 1);
  const pageSize = searchParams.pageSize || 10;
  
  return useQuery<SupplierQueryResult>({
    queryKey: ["suppliers", searchParams],
    queryFn: async () => {
      const search = searchParams.search || "";

      let response: ListSuppliersResponse;

      response = await getSuppliers(page, pageSize, search);

      return {
        suppliers: response.suppliers,
        totalCount: response.totalCount,
        page,
        pageSize
      };
    },
    // Keep previous data while fetching new data for better UX
    placeholderData: (previousData) => previousData,
    // Don't refetch when window regains focus
    refetchOnWindowFocus: false,
    // Stale time - how long data stays fresh (5 minutes)
    staleTime: 5 * 60 * 1000,
    // Cache time - how long inactive data stays in cache (10 minutes)
    gcTime: 10 * 60 * 1000,
  });
};
